import { useContext } from 'react';
import { ToastContext } from './Toast.context';

export const useToast = () => {
  const toastContext = useContext(ToastContext);
  if (toastContext === undefined) {
    throw new Error('useToast must be inside of ToastContext');
  }
  return toastContext;
};
